export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  description: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  updatedAt: string;
  chapters: ComicChapter[];
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '国漫', slug: 'guoman' },
  { name: '日漫', slug: 'riman' },
  { name: '韩漫', slug: 'hanman' },
  { name: '美漫', slug: 'meiman' },
  { name: '其他', slug: 'other' },
];

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'xinghe-dadi',
    title: '星河大帝',
    author: '梦入神机',
    description: '浩瀚星河，万族争锋。少年江离从地球出发，踏上修炼之路，一路披荆斩棘，最终成为星河大帝的传奇故事。在这片无垠的宇宙中，他将面对无数强敌，揭开宇宙最深处的秘密。热血战斗、华丽特效，带你领略一个波澜壮阔的星际世界。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20epic%20sci-fi%20comic%20cover%20illustration%20with%20a%20young%20warrior%20in%20ancient%20robe%20standing%20before%20a%20vast%20starry%20galaxy%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20crimson%20tones%2C%20clean%20composition%2C%20manga%20art%20style%2C%20white%20background%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '国漫',
    categorySlug: 'guoman',
    tags: ['热血', '玄幻', '战斗'],
    status: '连载中',
    rating: 9.2,
    views: 12500000,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 45 }, (_, i) => ({
      id: `ch-1-${i + 1}`,
      title: `第${i + 1}话 ${i < 10 ? '初入星河' : i < 20 ? '星际争霸' : i < 35 ? '万族大战' : '终章序曲'}`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 15)).padStart(2, '0')}-${String(30 - (i % 30)).padStart(2, '0')}`,
    })),
  },
  {
    id: '2',
    slug: 'jueshi-wuhun',
    title: '绝世武魂',
    author: '洛城东',
    description: '少年林枫偶得绝世武魂，从此踏上逆天改命之路。武魂世界，弱肉强食，唯有不断变强才能守护所爱之人。一剑破万法，一拳镇山河，见证一个废材少年如何一步步成为绝世强者的热血传奇！',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20martial%20arts%20fantasy%20comic%20cover%20with%20a%20young%20swordsman%20in%20flowing%20white%20robes%2C%20glowing%20spirit%20energy%20surrounding%20him%2C%20ancient%20Chinese%20architecture%20background%2C%20warm%20golden%20and%20amber%20color%20palette%2C%20clean%20manga%20art%20style%2C%20simple%20light%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '国漫',
    categorySlug: 'guoman',
    tags: ['热血', '武侠', '修炼'],
    status: '连载中',
    rating: 9.0,
    views: 10800000,
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 38 }, (_, i) => ({
      id: `ch-2-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 13)).padStart(2, '0')}-${String(28 - (i % 28)).padStart(2, '0')}`,
    })),
  },
  {
    id: '3',
    slug: 'yanwang-tianxia',
    title: '燕王天下',
    author: '月关',
    description: '大燕王朝，风云变幻。燕王朱棣以雷霆手段夺取天下，但真正的挑战才刚刚开始。宫廷权谋、江湖恩怨、沙场征战，一幅波澜壮阔的历史画卷徐徐展开。改编自知名作家月关同名小说，带你重回那个热血沸腾的时代。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20manhua%20cover%20with%20a%20noble%20prince%20in%20magnificent%20ancient%20Chinese%20imperial%20robe%2C%20dragon%20motif%2C%20palace%20in%20background%2C%20rich%20warm%20red%20and%20gold%20tones%2C%20elegant%20composition%2C%20clean%20oriental%20art%20style%2C%20light%20cream%20background&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '国漫',
    categorySlug: 'guoman',
    tags: ['历史', '权谋', '战争'],
    status: '已完结',
    rating: 9.5,
    views: 15600000,
    updatedAt: '2026-07-15',
    chapters: Array.from({ length: 52 }, (_, i) => ({
      id: `ch-3-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(6 - Math.floor(i / 18)).padStart(2, '0')}-${String(20 - (i % 20)).padStart(2, '0')}`,
    })),
  },
  {
    id: '4',
    slug: 'mofa-shaonu-yu-mowang',
    title: '魔法少女与魔王',
    author: '星野琉璃',
    description: '平凡少女小樱意外觉醒魔法力量，却与魔王签订了契约。从此她的生活天翻地覆——白天是普通高中生，晚上则要对抗各种来自异世界的威胁。搞笑日常与热血战斗交织，一段温暖又刺激的魔法冒险就此展开！',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20magical%20girl%20comic%20cover%20with%20a%20cute%20schoolgirl%20in%20frilly%20magical%20dress%2C%20sparkling%20magic%20effects%2C%20pastel%20pink%20and%20lavender%20color%20scheme%2C%20cherry%20blossom%20petals%2C%20clean%20anime%20illustration%20style%2C%20soft%20white%20background&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '日漫',
    categorySlug: 'riman',
    tags: ['魔法', '校园', '恋爱'],
    status: '连载中',
    rating: 8.8,
    views: 9800000,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 33 }, (_, i) => ({
      id: `ch-4-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 11)).padStart(2, '0')}-${String(25 - (i % 25)).padStart(2, '0')}`,
    })),
  },
  {
    id: '5',
    slug: 'jianyu-chuanshuo',
    title: '剑域传说',
    author: '萧鼎',
    description: '剑域，一个以剑为尊的世界。少年林凡手握三尺青锋，从最低级的剑士开始，一步步攀登剑道巅峰。这里有惊心动魄的剑术对决，有感人至深的师徒情谊，更有关于剑道本源的深刻思考。一剑在手，天下我有！',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20sword%20fantasy%20manhua%20cover%20with%20a%20young%20swordsman%20holding%20a%20glowing%20ancient%20sword%2C%20floating%20mountains%20and%20waterfalls%20in%20background%2C%20ethereal%20mist%2C%20cool%20silver%20and%20jade%20green%20tones%2C%20traditional%20Chinese%20ink%20painting%20style%2C%20clean%20composition&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '国漫',
    categorySlug: 'guoman',
    tags: ['仙侠', '剑道', '修炼'],
    status: '连载中',
    rating: 9.1,
    views: 11200000,
    updatedAt: '2026-08-01',
    chapters: Array.from({ length: 40 }, (_, i) => ({
      id: `ch-5-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 14)).padStart(2, '0')}-${String(22 - (i % 22)).padStart(2, '0')}`,
    })),
  },
  {
    id: '6',
    slug: 'yuwang-dushi',
    title: '欲望都市',
    author: '金泰亨',
    description: '首尔繁华都市的背后，隐藏着不为人知的欲望与秘密。年轻有为的律师朴志勋卷入了一场惊天的财阀阴谋中，在金钱、权力与爱情的漩涡里，他将如何抉择？韩国顶级漫画家倾力打造，画风精致唯美，剧情扣人心弦。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20drama%20comic%20cover%20with%20a%20handsome%20man%20in%20modern%20suit%20and%20elegant%20woman%20in%20evening%20dress%2C%20city%20nightscape%20with%20neon%20lights%2C%20sophisticated%20atmosphere%2C%20deep%20burgundy%20and%20gold%20accents%2C%20clean%20digital%20illustration%2C%20simple%20dark%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '韩漫',
    categorySlug: 'hanman',
    tags: ['都市', '恋爱', '悬疑'],
    status: '连载中',
    rating: 8.6,
    views: 8900000,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 29 }, (_, i) => ({
      id: `ch-6-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 10)).padStart(2, '0')}-${String(18 - (i % 18)).padStart(2, '0')}`,
    })),
  },
  {
    id: '7',
    slug: 'lingshi-dalu',
    title: '灵石大陆',
    author: '唐家三少',
    description: '在灵石大陆上，每个人都拥有独特的灵石能力。少年唐舞麟天生武魂弱小，却意外获得了一枚神秘的七彩灵石。从此他的人生发生了翻天覆地的变化，一步步揭开灵石大陆隐藏了万年的秘密。经典玄幻巨作改编漫画版，震撼来袭！',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20adventure%20manhua%20cover%20with%20a%20young%20hero%20holding%20a%20glowing%20rainbow%20crystal%2C%20magical%20forest%20and%20ancient%20ruins%20background%2C%20vibrant%20emerald%20and%20sapphire%20tones%2C%20dynamic%20composition%2C%20clean%20manga%20art%20style%2C%20bright%20ethereal%20atmosphere&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '国漫',
    categorySlug: 'guoman',
    tags: ['玄幻', '冒险', '热血'],
    status: '连载中',
    rating: 9.3,
    views: 14200000,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: `ch-7-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 16)).padStart(2, '0')}-${String(24 - (i % 24)).padStart(2, '0')}`,
    })),
  },
  {
    id: '8',
    slug: 'zuozhe-yu-bianji',
    title: '漫画家与编辑大人',
    author: '佐藤健',
    description: '新人漫画家小林一郎遇到了严厉又可爱的编辑清水小姐。在截稿日的追逐中，两人的关系从单纯的作者与编辑，渐渐发展出了微妙的情感。一部关于梦想、爱情与漫画创作的温馨喜剧，带你走进漫画家的真实日常！',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20slice%20of%20life%20romance%20manga%20cover%20with%20a%20young%20male%20manga%20artist%20at%20desk%20and%20a%20cute%20female%20editor%20holding%20manuscript%2C%20warm%20cozy%20studio%20setting%2C%20soft%20pastel%20pink%20and%20cream%20tones%2C%20clean%20anime%20illustration%2C%20simple%20light%20background&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '日漫',
    categorySlug: 'riman',
    tags: ['恋爱', '日常', '职场'],
    status: '已完结',
    rating: 9.0,
    views: 7600000,
    updatedAt: '2026-06-20',
    chapters: Array.from({ length: 24 }, (_, i) => ({
      id: `ch-8-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(5 - Math.floor(i / 8)).padStart(2, '0')}-${String(15 - (i % 15)).padStart(2, '0')}`,
    })),
  },
  {
    id: '9',
    slug: 'tiancai-wanfa',
    title: '天才玩家',
    author: '李东旭',
    description: '当虚拟现实游戏"天元"风靡全球，普通大学生林浩意外获得了顶级隐藏职业——天才玩家。在这个奇幻的游戏世界里，他将挑战极限、结交挚友，甚至揭开游戏背后隐藏的惊天阴谋。韩漫顶级画风，每一帧都是壁纸级别的精美画面！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20fantasy%20webtoon%20cover%20with%20a%20young%20gamer%20in%20futuristic%20armor%2C%20holographic%20game%20interface%20elements%2C%20cyberpunk%20city%20skyline%2C%20vibrant%20neon%20blue%20and%20purple%20accents%2C%20dynamic%20action%20pose%2C%20clean%20digital%20art%20style%2C%20dark%20gradient%20background&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '韩漫',
    categorySlug: 'hanman',
    tags: ['游戏', '冒险', '科幻'],
    status: '连载中',
    rating: 8.9,
    views: 10100000,
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 36 }, (_, i) => ({
      id: `ch-9-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 12)).padStart(2, '0')}-${String(20 - (i % 20)).padStart(2, '0')}`,
    })),
  },
];

export function getComicsByCategory(slug: string): Comic[] {
  if (slug === 'all') return comics;
  return comics.filter((c) => c.categorySlug === slug);
}

export function getComicBySlug(slug: string): Comic | undefined {
  return comics.find((c) => c.slug === slug);
}

export function getPopularComics(limit: number = 8): Comic[] {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getLatestComics(limit: number = 8): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
}